import { selectHasStagedChanges, selectLoadedProfileId } from '../state/selectors';
import { useAnalysisDefinitionStore } from '../state/useAnalysisDefinitionStore';

/**
 * Whether the given analysis has unsaved edits in the definition store. The store
 * holds one analysis at a time, so staged edits only count for the analysis they
 * were loaded for; processing runs the saved version, which these edits are not in.
 */
export const useAnalysisHasStagedChanges = (analysisProfileId: string | undefined): boolean => {
  const hasStagedChanges = useAnalysisDefinitionStore(selectHasStagedChanges);
  const loadedProfileId = useAnalysisDefinitionStore(selectLoadedProfileId);
  return (
    hasStagedChanges && analysisProfileId !== undefined && loadedProfileId === analysisProfileId
  );
};
